export enum AppealIdType {
    Unknown = 0,
    Job = 1,
    /* This value is deprecated.*/
    Report = 2
}

export enum AppealPage { 
    Landing = 0,
    Hip = 1,
    Form = 2,
    PreSubmission = 3,
    Submission = 4,
    Expiry = 5
}

export enum AppealType {
    Unknown = 0,
    Account = 1,
    Content = 2,
}